// Progressive enhancement only; native Trade handles variants and cart submission.
(() => {
  const enhance = () => {
    document.querySelectorAll('.lm-review-link').forEach(link => {
      if (link.dataset.lmReady) return;
      link.dataset.lmReady = 'true';
      link.addEventListener('click', () => {
        const section = document.getElementById('LMProductReviews');
        if (section) { section.setAttribute('tabindex', '-1'); section.focus({ preventScroll: true }); }
      });
    });
  };
  document.addEventListener('DOMContentLoaded', enhance);
  document.addEventListener('shopify:section:load', enhance);
})();
